export default "__VITE_ASSET__EEea5GUM__"